import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Injectable } from '@angular/core';

@Injectable()
export class FikaAccessoriesIndexCardStackContentViewModel extends PrintCardContentViewModel {}
